// extracted by mini-css-extract-plugin
export default {"locationCard":"LocationCard_locationCard__lgH+P","locationCard__img":"LocationCard_locationCard__img__+wszR","locationCard__title":"LocationCard_locationCard__title__RNf6t"};